import React, { useEffect, useRef, useState } from "react";
import { Star } from "lucide-react";
import { ACUITY_URL } from "../mock";

// Primary CTA button - opens Acuity booking (configurable) or scrolls to form
export const CtaButton = ({ children, className = "", toForm = false, size = "lg", ...props }) => {
  const handleClick = (e) => {
    if (toForm) {
      e.preventDefault();
      const el = document.getElementById("quiz-form");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (props.onClick) props.onClick(e);
  };
  const sizes = {
    lg: "px-9 py-4 text-[15px]",
    md: "px-6 py-3 text-sm",
    sm: "px-5 py-2.5 text-xs",
  };
  return (
    <a
      href={toForm ? "#quiz-form" : ACUITY_URL}
      target={toForm ? undefined : "_blank"}
      rel={toForm ? undefined : "noopener noreferrer"}
      onClick={handleClick}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-brand-sage font-sans font-semibold uppercase tracking-[0.14em] text-brand-ivory shadow-[0_10px_30px_-8px_rgba(46,69,57,0.6)] transition-all duration-300 hover:bg-brand-sagedark hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-10px_rgba(46,69,57,0.7)] active:translate-y-0 ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </a>
  );
};

export const StarRating = ({ className = "", size = 16 }) => (
  <div className={`flex items-center gap-0.5 ${className}`}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={size} className="fill-brand-gold text-brand-gold" />
    ))}
  </div>
);

// Wrapper that reveals children on scroll into view
export const Reveal = ({ children, className = "", delay = 0 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.unobserve(node);
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export const SectionEyebrow = ({ children, center = false }) => (
  <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
    <span className="h-px w-8 bg-brand-gold" />
    <span className="font-sans text-xs font-semibold uppercase tracking-[0.28em] text-brand-golddark">
      {children}
    </span>
    {center && <span className="h-px w-8 bg-brand-gold" />}
  </div>
);
